import { CssBaseline, ThemeProvider } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import Routes from './routes';
import { theme } from './Theme';


function App() {
  return (
    <ThemeProvider theme={theme}>
         
         <CssBaseline/>
        <BrowserRouter>
        <Routes/>
        </BrowserRouter>
         
         
    </ThemeProvider>
  );
}

export default App;
